<template>
	<div>
		<!-- =========== End of Loader ============ -->

		<main class="main hidden">
			<!-- =========== Start of Navigation (main menu) ============ -->
			<header class="navbar navbar-expand-lg navbar-dark">
				<div class="container position-relative">
					<router-link to="" class="navbar-brand">
						<img
							class="navbar-brand__regular"
							src="/assets/logo.png"
							alt="brand-logo"
							width="80px"
							height="80px"
						/>
					</router-link>
					<!--  End of brand logo -->
				</div>
				<!-- end of container -->
			</header>
			<!-- =========== End of Navigation (main menu)  ============ -->

			<!-- =========== Start of Body ============ -->
			<section
				class="space bg-color--dark--1 h-min-100vh d-flex align-items-center"
			>
				<div class="svg-shape--top w-100 opacity--05">
					<img
						src="/assets/img/wave-8.svg"
						alt="wave"
						class="svg fill--white"
					/>
				</div>
				<!-- end of whole area svg bg -->
				<div class="svg-shape--top opacity--10">
					<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
				</div>
				<!-- end of top right mini svg shape -->

				<div class="container">
					<div class="row">
						<div class="col-12 mx-auto color--white text-center mb-4 mb-lg-5">
							<h1 class="h2-font mb-1 text-white">
								{{ $t("register.baseRegister") }}
							</h1>
						</div>
						<div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-9 mx-auto">
							<div
								class="form--v5 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
							>
								<form class="form">
									<div
										class="alert alert-danger"
										role="alert"
										id="alert"
										v-show="alert"
									>
										<ul>
											<li v-for="err in errors" :key="err">
												{{ err[0] }}
											</li>
										</ul>
									</div>
									<div class="container">
										<!--NAme & lastName -->
										<div class="row justify-content-between">
											<!-- name-->
											<div class="col-md-5">
												<!-- Name -->
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.name") }}</label
													>
													<input
														id="name"
														type="text"
														v-model.trim="$v.name.$model"
														class="form-control form-control-sm input-sm form__label"
														:class="{ 'is-invalid': $v.name.$error }"
														@blur="$v.name.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.name.required"
													>
														ورود نام لازم است
													</div>
												</div>
											</div>

											<!-- last Name -->
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.lastName") }}</label
													>
													<input
														id="lastName"
														type="text"
														v-model.trim="$v.lastName.$model"
														class="form-control input-sm"
														:class="{ 'is-invalid': $v.lastName.$error }"
														@blur="$v.lastName.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.lastName.required"
													>
														ورود نام خانوادگی لازم است
													</div>
												</div>
											</div>
										</div>
										<!--Melli code & FAther name -->
										<div class="row justify-content-between">
											<!--Melli code-->
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.melliCode") }}</label
													>
													<input
														id="melliCode"
														type="number"
														@wheel="$event.target.blur()"
														v-model.trim="$v.melliCode.$model"
														class="form-control"
														:class="{ 'is-invalid': $v.melliCode.$error }"
														@blur="$v.melliCode.$touch()"
													/>

													<div
														class="invalid-feedback"
														v-if="!$v.melliCode.checkMelliCode"
													>
														کد ملی معتبر نیست
													</div>
												</div>
											</div>
											<!--FAther name -->
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.fatherName") }}</label
													>
													<input
														id="fatherName"
														type="text"
														v-model.trim="$v.fatherName.$model"
														class="form-control"
														:class="{ 'is-invalid': $v.fatherName.$error }"
														@blur="$v.fatherName.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.fatherName.required"
													>
														ورود نام پدر الزامی است
													</div>
												</div>
											</div>
										</div>
										<!--gender -->
										<div class="row justify-content-between">
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase form-check-inline form-check-label font-size--15 font-w--500"
														>{{ $t("register.gender") }}</label
													>

													<div class="form-check form-check-inline mt-2">
														<input
															id="gender"
															class="form-check-input"
															type="radio"
															name="inlineRadioOptions"
															value="m"
															v-model.trim="$v.gender.$model"
															:class="{ 'is-invalid': $v.gender.$error }"
															@blur="$v.gender.$touch()"
														/>
														<label
															class="form-check-label"
															for="inlineRadioMan"
															>{{ $t("register.male") }}</label
														>
													</div>
													<div class="form-check form-check-inline">
														<input
															class="form-check-input"
															type="radio"
															name="inlineRadioOptions"
															id="inlineRadioWoman"
															value="f"
															v-model.trim="$v.gender.$model"
															:class="{ 'is-invalid': $v.gender.$error }"
															@blur="$v.gender.$touch()"
														/>
														<label
															class="form-check-label"
															for="inlineRadioWoman"
															>{{ $t("register.female") }}</label
														>
													</div>
													<div
														class="invalid-feedback"
														v-if="!$v.gender.required"
													>
														ورود جنسیت الزامی است
													</div>
												</div>
											</div>
										</div>
										<!--Password & rePassword -->
										<div class="row justify-content-between">
											<!--Password -->
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.password") }}</label
													>
													<input
														id="password"
														type="password"
														v-model.trim="$v.password.$model"
														class="form-control"
														:class="{ 'is-invalid': $v.password.$error }"
														@blur="$v.password.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.password.required"
													>
														لطفا کلمه عبور را وارد کنید
													</div>

													<div
														class="invalid-feedback"
														v-if="!$v.password.minLength"
													>
														کلمه عبور باید حداقل شامل
														{{ $v.password.$params.minLength.min }} کاراکتر باشد
													</div>
												</div>
											</div>
											<!-- REPASSWORD -->
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.repassword") }}</label
													>
													<input
														id="repassword"
														type="password"
														v-model.trim="$v.rePassword.$model"
														:class="{ 'is-invalid': $v.rePassword.$error }"
														class="form-control"
														@blur="$v.rePassword.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.rePassword.sameAs"
													>
														تکرار رمز عبور با رمز عبور مطابق نیست
													</div>
												</div>
											</div>
										</div>
										<!-------------- register user onformations ------------->

										<div class="row justify-content-between">
											<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.phone") }}</label
													>
													<input
														id="phone"
														type="number"
														v-model.trim="$v.phone.$model"
														@wheel="$event.target.blur()"
														class="form-control input-sm"
														placeholder="02112345678"
														:class="{ 'is-invalid': $v.phone.$error }"
														@blur="$v.phone.$touch()"
													/>
													<div
														class="invalid-feedback"
														v-if="!$v.phone.required"
													>
														ورود تلفن لازم است
													</div>
													<div
														class="invalid-feedback"
														v-if="!$v.phone.minLength || !$v.phone.maxLength"
													>
														شماره تلفن نا معتبر است
													</div>
												</div>
											</div>
										</div>
									</div>

									<div
										class="d-flex justify-content-between align-items-center flex-column"
									>
										<hr />
										<div class="container">
											<h4 class="text-dark text-align-center">
												{{ $t("register.addressInfo") }}
											</h4>
											<br />

											<div class="form-row justify-content-between">
												<div class="col">
													<div class="form-group">
														<label
															class="form__label text-uppercase font-size--15 font-w--500"
															>{{ $t("register.province") }}</label
														>
														<input
															id="province"
															type="text"
															v-model.trim="$v.province.$model"
															class="form-control"
															:class="{ 'is-invalid': $v.province.$error }"
															@blur="$v.province.$touch()"
														/>
														<div
															class="invalid-feedback"
															v-if="!$v.province.required"
														>
															ورود استان لازم است
														</div>
													</div>
												</div>

												<div class="col">
													<div class="form-group">
														<label
															class="form__label text-uppercase font-size--15 font-w--500"
															>{{ $t("register.city") }}</label
														>
														<input
															id="city"
															type="text"
															v-model.trim="$v.city.$model"
															class="form-control"
															:class="{ 'is-invalid': $v.city.$error }"
															style="radius=10px"
															@blur="$v.city.$touch()"
														/>
														<div
															class="invalid-feedback"
															v-if="!$v.city.required"
														>
															ورود شهر لازم است
														</div>
													</div>
												</div>
												<div class="col-md-8">
													<div class="form-group">
														<label
															class="form__label text-uppercase font-size--15 font-w--500"
															>{{ $t("register.address") }}</label
														>
														<textarea
															id="address"
															type="text"
															v-model.trim="$v.address.$model"
															class="form-control"
															:class="{ 'is-invalid': $v.address.$error }"
															@blur="$v.address.$touch()"
														/>
														<div
															class="invalid-feedback"
															v-if="!$v.address.required"
														>
															ورود آدرس لازم است
														</div>
													</div>
												</div>
											</div>
										</div>
										<br />
										<br />
										<button
											class="btn btn-bg--primary btn-size--md btn-hover--3d"
											type="submit"
											@click.prevent="baseRegister"
										>
											<span class="btn__text">{{ $t("login.signUp") }}</span>
										</button>
									</div>
								</form>
								<!-- end of form -->
							</div>
							<!-- end of from area -->
						</div>
						<!-- end of col -->
					</div>
					<!-- end of row -->
				</div>
				<!-- end of container -->
			</section>
			<!-- =========== End of Body ============ -->
		</main>
	</div>
</template>

<script>
	// import {
	// 	required,
	// 	minLength,
	// 	sameAs,
	// } from "vuelidate/lib/validators";
	import { baseRegisterMixin } from "../../mixins/validationMixin";

	export default {
		data() {
			return {
				alert: false,
				errors: [],
				melliCode: "",

				password: "",
				rePassword: "",
				//-----------------------
				name: "",
				lastName: "",
				fatherName: "",
				gender: "",
				phone: "",
				province: "",
				city: "",
				address: "",
			};
		},
		mixins: [baseRegisterMixin],
		beforeCreate() {
			if (localStorage.getItem("mobile_number") == null) {
				this.$router.push("/sign-up");
			}
		},
		methods: {
			baseRegister() {
				let mobile_number = localStorage.getItem("mobile_number");
				let password = this.password;
				let melliCode = this.melliCode;
				const baseData = {
					mobile_number: mobile_number,
					melli_code: this.melliCode,
					password: password,
					re_password: this.rePassword,
				};
				const loginData = {
					mobile_number: mobile_number,
					password: password,
				};

				const user_register_data = {
					first_name: this.name,
					last_name: this.lastName,
					father_name: this.fatherName,
					gender: this.gender,
					// number: this.phone,
					province: this.province,
					city: this.city,
					address: this.address,
					mobile_number: mobile_number,
					melli_code: melliCode,
					phone_number: this.phone,
				};
				this.$v.$touch();
				if (this.$v.$invalid) {
					this.submitStatus = "ERROR";
					this.$noty.info(this.$t("alert.alertInvalidField"));
				} else {
					this.$store
						.dispatch("baseRegister", baseData)
						.then((response) => {
							console.log(response);

							this.$store
								.dispatch("login", loginData)
								.then(() => {
									this.$store
										.dispatch("registerUser", user_register_data)
										.then(() => {
											this.$router.push("/customer/set-level");
										})
										.catch((err) => {
											console.log("err", err);
											this.alert = true;
											this.errors = err.body;
										});
								})
								.catch((err) => {
									console.log("err", err);
									this.alert = true;
									this.errors = err.body;
								})
								.catch((err) => {
									console.log("err", err);
									this.alert = true;
									this.errors = err.body;
								});
						})
						.catch((err) => {
							console.log("err", err);
							this.alert = true;
							this.errors = err.body;
						});
				}
			},
		},

		// validations: {
		// 	melli_code: {
		// 		required,
		// 		checkMelliCode(code) {
		// 			if (
		// 				!/^\d{10}$/.test(code) ||
		// 				code == "0000000000" ||
		// 				code == "1111111111" ||
		// 				code == "2222222222" ||
		// 				code == "3333333333" ||
		// 				code == "4444444444" ||
		// 				code == "5555555555" ||
		// 				code == "6666666666" ||
		// 				code == "7777777777" ||
		// 				code == "8888888888" ||
		// 				code == "9999999999"
		// 			)
		// 				return false;
		// 			var check = parseInt(code[9]);
		// 			var sum = 0;
		// 			var i;
		// 			for (i = 0; i < 9; ++i) {
		// 				sum += parseInt(code[i]) * (10 - i);
		// 			}
		// 			sum %= 11;
		// 			return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
		// 		},
		// 	},
		// 	password: {
		// 		minLength: minLength(6),
		// 		required,
		// 	},
		// 	rePassword: {
		// 		required,
		// 		sameAs: sameAs("password"),
		// 	},
		// 	name: {
		// 		required,
		// 	},
		// 	lastName: {
		// 		required,
		// 	},
		// 	fatherName: {
		// 		required,
		// 	},
		// 	phone: {
		// 		required,
		// 		minLength: minLength(11),
		// 		maxLength: maxLength(11),
		// 	},
		// 	province: {
		// 		required,
		// 	},
		// 	city: {
		// 		required,
		// 	},
		// 	address: {
		// 		required,
		// 	},
		// },
	};
</script>

<style>
	.vpd-icon-btn {
		display: flex;
		width: 1%;
		cursor: pointer;
		padding: 0 10px;
	}
</style>
